import React from 'react';

import classnames from 'classnames';
import { Connection, Driver } from '@bringg/types';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import ReactDOMServer from 'react-dom/server';
import { useRoutesMonitoringTranslations } from '@bringg-frontend/monitoring';

import { tooltipProvider } from 'bringg-web/features/monitoring/shared/components/tooltips/tooltip-render-provider';
import StatusDot from '../../status-dot/status-dot';

import s from '../tooltip.module.scss';
import styles from './driver-tooltip.module.scss';

interface DriverTooltipProps {
	driver: Driver;
}

const DriverTooltip = ({ driver }: DriverTooltipProps) => {
	const { status, name, online, offline, unavailable, onABreak } = useRoutesMonitoringTranslations();
	const isOnShift = !!driver.active_shift_id;

	if (!isOnShift) {
		return null;
	}

	let driverStatus = driver.status === Connection.Online ? online : offline;
	let statusClass = driver.status === Connection.Online ? styles.online : styles.offline;

	const isUnavailable = !!driver.current_unavailability_id;
	const isOnBreak = !!driver.is_on_break;

	if (isUnavailable) {
		statusClass = styles.unavailable;
		driverStatus = `${driverStatus} (${unavailable})`;
	}

	return (
		<div className={classnames(s.monitoringTooltip, s.mapTooltip)}>
			{tooltipProvider.renderText(name, driver.name)}
			<div className={styles.driverStatus}>
				{tooltipProvider.renderText(status, driverStatus)}
				<StatusDot className={styles.dot} statusClass={statusClass} />
			</div>
			{isOnBreak && (
				<div className={styles.breakContainer} data-test-id="on-a-break">
					<BringgIcon iconName={BringgFontIcons.Cafe} className={styles.coffeeIcon}></BringgIcon>
					<span>{onABreak}</span>
				</div>
			)}
		</div>
	);
};

export const driverTooltipProvider = (driver: Driver): string => {
	return ReactDOMServer.renderToString(<DriverTooltip driver={driver}></DriverTooltip>);
};
